module.exports = __webpack_public_path__ + "img/1800.600954b2.jpg";